import axios from "axios";

const RootDevURI = "https://localhost:44315";
// const RootProdURI = 'https://test-tpcos-service.scgp.co.th'
const RootProdURI = "https://tpcos.scg.com:4433";

export const RootURI =
  process.env.NODE_ENV === "production" ? RootProdURI : RootDevURI;
const Timeout = 1000 * 60 * 3;

export const tpcOsAxios = axios.create({
  baseURL: RootURI,
  timeout: Timeout,
  validateStatus: (status) => {
    return status === 401 || status === 400 || (status >= 200 && status < 300);
  },
});

// axios.defaults.headers.common["Authorization"] = "Bearer " + token;
